export async function updateGameSettings({
  token,
  userId,
  stageId,
  themeName,
  user_type,
  current_mode,
  questions_no,
  time_duration,
  points,
  show_question,
  shuffle_questions,
  lobby_link,
  lobby_name,
  lobby_pin,
  email,
  fullName,
  employeeId,
  reportid,
  winner,
}) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateGameSettings`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      ...(stageId != null && String(stageId).trim() !== '' ? { stageId } : {}),
      ...(themeName != null && String(themeName).trim() !== '' ? { themeName } : {}),
      ...(user_type != null && String(user_type).trim() !== '' ? { user_type } : {}),
      current_mode,
      questions_no,
      time_duration,
      points,
      show_question,
      ...(shuffle_questions != null ? { shuffle_questions } : {}),
      ...(lobby_link != null ? { lobby_link } : {}),
      ...(lobby_name != null && String(lobby_name).trim() !== '' ? { lobby_name } : {}),
      ...(lobby_pin != null && String(lobby_pin).trim() !== '' ? { lobby_pin } : {}),
      ...(email != null ? { email } : {}),
      ...(fullName != null ? { fullName } : {}),
      ...(employeeId != null ? { employeeId } : {}),
      ...(reportid != null ? { reportid } : {}),
      ...(winner != null && String(winner).trim() !== '' ? { winner } : {}),
    }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || 'Failed to update game settings');
  }
  if (data && data.success === false) {
    throw new Error(data.message || 'Failed to update game settings');
  }
  return data;
}

